import React from 'react'
import { Box, Typography } from '@mui/material'

interface FormSectionProps {
  title: string
  children: React.ReactNode
}

export const FormSection: React.FC<FormSectionProps> = ({ title, children }) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant='h6' sx={{ mb: 2, fontWeight: 600 }}>
        {title}
      </Typography>
      {children}
    </Box>
  )
}
